<template>
  <div>
    <div class="">
      <a-button type="primary" icon="plus" @click="showAddTeam(0)">
        新增运动队
      </a-button>
    </div>
    <div class="mt10 mb10">
      <el-form :inline="true" :model="form" class="ant-advanced-search-form" size="small">
        <el-form-item label="运动队名称">
          <el-input v-model="form.name" placeholder="请输入运动队名称" ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加时间">
          <el-date-picker
            v-model="form.addDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']" 
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="btnOperation('search')" icon="el-icon-search">查询</el-button >
          <el-button type="" @click="btnOperation('reload')" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 数据列表 -->
    <el-table element-loading-text="加载中" :data="dataSource">
      <el-table-column label="编号" align="center" type="index" width="50" />
      <el-table-column label="运动队名称" align="center" prop="name" width="150" />
      <el-table-column label="成员人数" align="center" prop="memberNum" />
      <el-table-column label="运动组个数" align="center" prop="sportGroupNum" />
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          <!-- <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="2"
            @change="switchChange(scope.row)"
          ></el-switch> -->
          {{scope.row.status == 1 ? '启用' : '禁用'}}
        </template>
      </el-table-column>
      <el-table-column label="添加时间" align="center" prop="createTime" width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
        </template>
      </el-table-column>
      <el-table-column label="添加人" align="center" prop="createBy" />
      <el-table-column label="操作" align="center" fixed="right" width="360">
        <template slot-scope="scope">
          <el-button size="small" plain type="primary" @click="showAddTeam(1, scope.row)" >编辑</el-button >
          <el-button size="small" plain type="danger" @click="handleDel(scope.row)" >删除</el-button >
          <el-button size="small" plain type="primary" @click="$emit('operate', scope.row.id)" >运动组</el-button >
          <el-button size="small" plain type="primary" @click="manageSetting(scope.row)" >设置管理员</el-button >
        </template>
      </el-table-column>
    </el-table>

    <pagination :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize" @pagination="_getList" />

    <!-- 新建运动队 -->
    <el-dialog
      :title="addTitle"
      :visible.sync="addTeam"
      width="700px"
      append-to-body
    >
      <el-form
        ref="addTeam"
        :model="addTeamForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="运动队名称:" prop="name">
          <el-input
            clearable
            size="small"
            style="width: 400px"
            placeholder="请输入运动队名称"
            v-model="addTeamForm.name"
          />
        </el-form-item>
        <el-form-item label="运动队介绍:" prop="introduce">
          <el-input
            :rows="4"
            show-word-limit
            type="textarea"
            maxlength="100"
            placeholder="请输入运动队介绍"
            style="width: 400px"
            v-model="addTeamForm.introduce"
          />
        </el-form-item>
        <el-form-item label="启用/关闭:" prop="status">
          <el-switch v-model="addTeamForm.status" :active-value="1" :inactive-value="2" ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  
    <!-- 设置管理员 -->
    <el-dialog
      title="设置管理员"
      :visible.sync="settingShow"
      width="1000px"
      append-to-body
    >
      <el-button type="primary" icon="el-icon-plus" @click="adminAdd">添加管理员</el-button>

      <el-table element-loading-text="加载中" :data="adminList" class="mt20" style="min-height: 240px">
        <el-table-column label="编号" align="center" type="index" width="50" />
        <el-table-column label="姓名" align="center" prop="name" width="120" />
        <el-table-column label="账号" align="center" prop="phone" />
        <el-table-column label="身份证号码" align="center" prop="idCardNo" />
        <el-table-column label="添加时间" align="center" prop="createTime" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button size="small" plain type="primary" @click="editAdmin(scope.row)" >编辑</el-button >
            <el-button size="small" plain type="danger" @click="delAdmin(scope.row)" >删除</el-button >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :title="adminForm.id ? '编辑管理员': '添加管理员'"
      :visible.sync="adminShow"
      width="700px"
      append-to-body
    >
      <el-form
        ref="adminForm"
        :model="adminForm"
        :rules="adminRules"
        label-width="120px"
      >
        <el-form-item label="姓名:" prop="name">
          <el-input
            clearable
            size="small"
            placeholder="请输入姓名"
            v-model="adminForm.name"
          />
        </el-form-item>
        <el-form-item label="账号:" prop="phone">
          <el-input
            clearable
            size="small"
            placeholder="请输入账号"
            v-model="adminForm.phone"
          />
        </el-form-item> 
        <el-form-item label="身份证号码:" prop="idCardNo">
          <el-input
            clearable
            size="small"
            placeholder="请输入身份证号码"
            v-model="adminForm.idCardNo"
          />
        </el-form-item> 
        <el-form-item label="" prop="">
          登录初始密码默认为身份证后六位
        </el-form-item> 
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adminShow = false">取 消</el-button>
        <el-button type="primary" @click="adminSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import * as API_Member from "@/api/train/member";

export default {
  data() {
    return {
      id: 0,
      addTitle: "新增运动队",
      form: {
        name: null,
        status: null,
        addDate: null,
        pageNum: 1,
        pageSize: 10,
      },
      addTeam: false,
      addTeamForm: {
        name: null,
        introduce: null,
        status: 1,
      },
      rules: {
        name: [{ required: true, message: "请输入运动队名称", trigger: "blur" }],
        // introduce: [{ required: true, message: "请输入运动队介绍", trigger: "blur", }],
        status: [{ required: true }],
      },
      adminRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        idCardNo: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确', trigger: 'blur' }
        ],
      },
      dataSource: [],
      curTeam: {},
      settingShow: false,
      adminList: [],
      adminShow: false,
      adminTitle: '添加管理员',
      adminForm: {
        name: '',
        phone: '',
        idCardNo: '',
        teamId: null,
        organizationId: null,
      },
    };
  },
  methods: {
    // 删除
    moment,
    handleDel(e) {
      console.log(e);
      this.$confirm(`确定删除该数据吗？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this._del(e);
        })
        .catch(() => {});
    },
    _del(record) {
      // console.log(record);
      const params = {
        ids: [record.id],
      };
      API_Member.teamDel(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success("删除成功");
          this._getList();
        }
      });
    },
    // 切换开关
    switchChange(e) {
      const params = {
        id: e.id,
        status: e.status,
      };
      API_Member.teamSwitch(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("状态修改成功");
          this._getList();
        }
      });
    },
    _getList() {
      let params = {
        ...this.form,
        startTime: this.form.addDate && +this.form.addDate[0],
        endTime: this.form.addDate && +this.form.addDate[1],
      };
      API_Member.getTeamList(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dataSource = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    cancel() {
      this.addTeamForm = { status: 1 };
      this.$refs.addTeam.resetFields();
      // this.$refs.addTeam.clearValidate();
      this.addTeam = false;
    },
    confirm() {
      this.$refs.addTeam
        .validate()
        .then((res) => {
          // console.log(res);
          const url = this.id ? "teamEdit" : "teamAdd";
          let { id, name, introduce, status } = this.addTeamForm;
          let params = { id, name, introduce, status, };
          API_Member[url](params).then((res) => {
            // console.log(res);
            this.$message.success("操作成功");
            this.cancel(); // 清空表单
            if (this.id) {
              this._getList();
            } else {
              this.reset();
            }
          });
        })
        .catch(() => {});
    },
    reset() {
      this.form = {
        name: null,
        status: null,
        addDate: null,
        pageNum: 1,
        pageSize: 10,
      };
      this._getList();
    },
    //查询重置
    btnOperation(type) {
      // console.log(this.form);
      switch (type) {
        case "search":
          this.form.pageNum = 1;
          this._getList();
          break;
        case "reload":
          this.reset();
          break;
      }
    },
    showAddTeam(type, row) {
      console.log(row);
      if (type == 0) {
        this.id = 0;
        this.addTitle = "新增运动队";
      } else {
        this.addTitle = "编辑运动队";
        this.id = row.id;
        this.addTeamForm = JSON.parse(JSON.stringify(row));
      }
      this.addTeam = true;
    },
    manageSetting(row) {
      console.log(row)
      this.curTeam = row
      this._getAdminList()
    },
    // 接口-管理员列表
    _getAdminList() {
      let params = {
        teamId: this.curTeam.id
      }
      API_Member.adminList(params).then((res) => {
        console.log(res);
        if(res.code == 200) {
          this.adminList = res.data
          this.settingShow = true
        }
      });
    },
    adminAdd() {
      this.adminShow = true
      this.adminForm = {
        teamId: this.curTeam.id,
        organizationId: this.curTeam.organizationId,
        name: '',
        phone: '',
        idCardNo: '',
      }
    },
    adminSubmit() {
      this.$refs.adminForm
        .validate()
        .then((res) => {
          const url = this.adminForm.id ? "adminEdit" : "adminAdd";
          // let params = {}
          API_Member[url](this.adminForm).then((res) => {
            console.log(res);
            if(res.code == 200) {
              this.$message.success("操作成功");
              this.adminShow = false
              this._getAdminList()
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    editAdmin(row) {
      console.log(row)
      this.adminForm = JSON.parse(JSON.stringify(row))
      this.adminShow = true
    },
    delAdmin(e) {
      console.log(e);
      this.$confirm(`确定删除该管理员吗？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this._delAdmin(e);
        })
        .catch(() => {});
    },
    _delAdmin(e) {
      API_Member.adminDel(e.id).then((res) => {
        console.log(res);
        this.$message.success("删除成功");
        this._getAdminList();
      });
    }
  },
  mounted() {
    this._getList();
  },
};
</script>
<style lang="less">
@import "/src/styles/common/common.less";
</style>
